export default "<mat-spinner></mat-spinner>\r\n";